export enum ClaimSource {
  EMPLOYER_SPONSORED = 'employer-sponsored',
  PRETAX = 'pretax',
}

export enum EmployerSponsoredClaimStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  REJECTED = 'rejected',
  NEEDS_RECEIPT = 'needs receipt',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export enum PretaxV2ClaimStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  OVERPAID = 'OVERPAID',
  COMPLETED = 'COMPLETED',
  REIMBURSED = 'REIMBURSED',
}

export enum CombinedClaimStatus {
  APPROVED = 'approved',
  PENDING = 'pending',
  REJECTED = 'rejected',
  NEEDS_RECEIPT = 'needs receipt',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  OVERPAID = 'overpaid',
  REIMBURSED = 'reimbursed',
}

// Pretax Reimbursed won't show up in the dropdown
// When user selects "reimbursement completed", that will include pretax reimbursed claims
export const CLAIM_STATUSES_MAPPING = [
  {
    name: 'approved',
    value: 'approved',
    subheader_value: 'approved',
  },
  {
    name: 'pending',
    value: 'pending',
    subheader_value: 'pending',
  },
  {
    name: 'rejected',
    value: 'rejected',
    subheader_value: 'rejected',
  },
  {
    name: 'overpaid',
    value: 'overpaid',
    subheader_value: 'overpaid',
  },
  {
    name: 'needs receipt',
    value: 'needs receipt',
    subheader_value: 'needsreceipt',
  },
  {
    name: 'reimbursement in progress',
    value: 'in_progress',
    subheader_value: 'inprogress',
  },
  {
    name: 'reimbursement completed',
    value: 'completed',
    subheader_value: 'completed',
  },
] as const;

export enum ClaimSubheader {
  APPROVED = 'Claim approved/reimbursed',
  PENDING = 'Claim in review',
  REJECTED = 'Claim not approved',
  NEEDSRECEIPT = 'Claim needs more info',
  OVERPAID = 'Claim was overpaid',
  INPROGRESS = 'Claims being reimbursed in installments',
  COMPLETED = 'Claims being reimbursed in installments are complete',
  ALL_CLAIMS = 'All claims',
}

export enum EmployerSponsoredClaimPaymentMethod {
  DIRECT_DEPOSIT = 'direct_deposit',
  PAYROLL = 'payroll',
}

// comes from alegeus
export enum PretaxClaimPaymentMethod {
  DIRECT_DEPOSIT = 'DirectDeposit',
  CHECK = 'Check',
  NONE = 'None',
}

// comes from alegeus
export enum PretaxClaimStatus {
  APPROVED = 'approved',
  PARTIALLY_APPROVED = 'partially approved',
  ACTIVE = 'active',
  REJECTED = 'rejected',
  NEEDS_RECEIPT = 'needs receipt',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CONFIRMED = 'confirmed',
  FULFILLED = 'fulfilled',
  SHIPPED = 'shipped',
  PAID = 'paid',
  PARTIALLY_PAID = 'partially paid',
  CANCELLED = 'cancelled',
  DECLINED = 'declined',
  PENDING_CANCEL = 'pending_cancel',
  DENIED = 'denied',
  PENDING = 'pending',
  PROCESSING = 'processing',
  DEFAULT = 'default',
  ENTERED_NOT_REVIEWED = 'entered<br>not reviewed',
  REVIEWED_PENDING_APPROVAL = 'reviewed<br>pending approval',
  CLAIM_ADJUSTED_OVERPAID = 'claim adjusted – overpaid',
}

export enum DirectDepositStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
